module.exports = __webpack_public_path__ + "assets/mobile_settings-2aa3dd.svg";